import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background: white;
  max-width: 500px;
  margin: auto;
  border-radius: 10px;

  header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    img {
      margin: 30px;
    }
  }

  .container {
    max-width: 1200px;
    width: 100%;
    padding: 20px 20px;
    margin: auto;
    flex: 1;
  }

  p {
    margin-bottom: 20px;
    text-align: justify;
  }

  .verification-section {
    .button-wrapper {
      margin-top: 15px;
    }

    .security-code-wrapper {
      display: flex;
      margin-bottom: 15px;

      label {
        margin: 5px 10px 0 0;
      }

      input {
        max-width: 200px;
      }

      .resend-button {
        display: block;
        background: none;
        border: none;
        text-decoration: underline;
        margin-top: 5px;
        cursor: pointer;
      }
    }

    .resend-confirm {
      margin-top: 1rem;
      font-size: smaller;
    }
  }

  .payment-preference-section {
    text-align: center;

    p {
      text-align: center;
    }

    table {
      width: 100%;
      margin: 20px auto;
      max-width: 1000px;
      border: 1px solid black;
      color: #0f2d62;

      .recommended-row {
        div {
          padding: 10px;
          font-size: 20px;
          text-transform: uppercase;
        }
      }

      .payment-method-wrapper {
        td {
          background-color: ${({ theme }) => theme.colors.primary};
          color: white;
          padding: 10px 0;

          div {
            font-size: 26px;
            text-transform: uppercase;
          }

          p {
            margin-bottom: 0;
            font-size: 13px;
          }
        }
      }

      .payment-feature-section {
        td {
          padding: 10px;
          text-align: left;
        }
        ul {
          list-style: none;
        }
      }

      .payment-method-section {
        td {
          text-align: left;
          padding: 0 10px 10px;

          .ant-radio-wrapper {
            font-size: 18px;
            color: #0f2d62;
          }
        }
      }
    }

    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      width: fit-content;
      margin: 20px auto;

      label {
        margin-inline-start: 0;

        a {
          text-decoration: underline;
        }
      }
    }

    .checkbox-wrapper {
      align-items: center;
      button {
        max-width: 200px;
      }
    }
  }

  .checkbox-wrapper {
    margin: 0 auto 50px;
    text-align: left;
    display: flex;
    flex-direction: column;
  }

  .last-section {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  footer {
    margin-top: 180px;

    .tifle-logo-wrapper {
      margin: 30px;
      padding: 5px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      div {
        margin-bottom: 5px;
        font-size: 11px;
      }

      img {
        width: 65px;
      }
    }
  }
`;
